export default __webpack_public_path__ + "static/media/logo_small_scrolled.d83eea05.svg";